module.exports = __webpack_public_path__ + "img/lowerTco.bb8ce794.png";